<script setup lang="ts">
import { toReadableDateFormat } from '@/composable/useFormatDatesAndTimes'

import { useAgreementStore } from '@/stores/agreement'

const agreementStore = useAgreementStore()

const {
  agreement,
} = storeToRefs(agreementStore)

const hasAgreementExpiringNotification = computed(() => !!agreement.value?.display_expiring_notification)
const hasAgreementExpiredNotification = computed(() => !!agreement.value?.display_expired_notification)
const contractEndDate = computed(() => agreement.value?.end_date || '')
</script>

<template>
  <VAlert
    v-if="hasAgreementExpiringNotification || hasAgreementExpiredNotification"
    class="mb-6 text-body-2"
    type="warning"
    density="compact"
    closable
  >
    <template v-if="hasAgreementExpiringNotification">
      <span v-dompurify-html="$t('pages.dashboard.expiring_alert', {expiringDate: toReadableDateFormat(contractEndDate)})" />
    </template>
    <template v-else>
      <span v-dompurify-html="$t('pages.dashboard.expired_alert', {expiredDate: toReadableDateFormat(contractEndDate)})" />
    </template>
  </VAlert>
</template>
